/* uc-swatch-price-display-v3-20261030
 * Price-label repair only. GETs Shopify product JSON; never submits a cart,
 * changes a variant ID, changes a price, or intercepts a product form.
 */
(() => {
  'use strict';
  if (String(window.Shopify?.theme?.id) !== '188133015737' || window.__ucSwatchPriceDisplay) return;
  window.__ucSwatchPriceDisplay = 'uc-swatch-price-display-v3-20261030';
  const script = document.currentScript?.matches('[data-uc-swatch-price-loader]') ? document.currentScript : document.querySelector('[data-uc-swatch-price-loader]');
  const currency = script?.dataset.ucCurrency || window.Shopify?.currency?.active;
  if (!/^[A-Z]{3}$/.test(currency || '')) return;
  const root = window.Shopify?.routes?.root || '/';
  const states = new WeakMap(), requests = new Map();
  const selector = 'product-form.uc-swatch-confidence';
  const slugify = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  function selection(node) {
    const section = document.getElementById('variant-selects-' + node.dataset.sectionId);
    const selected = section?.querySelector('input[name="Color"]:checked');
    const label = selected && section.querySelector('label[for="' + CSS.escape(selected.id) + '"]');
    const input = node.querySelector('.product-swatch-variant-id');
    const labelId = (label?.id || '').replace(/^swatch-/, '');
    const id = String(input?.value || labelId);
    if (!/^\d+$/.test(id) || (labelId && labelId !== id)) return null;
    return {id, price:label?.getAttribute('data-uc-swatch-price')?.trim() || '', handle:slugify(selected?.value)};
  }
  function setText(output, text) {
    if (output.textContent !== text) output.textContent = text;
  }
  async function productJSON(handle) {
    const key = currency + ':' + handle;
    const cached = requests.get(key);
    if (cached && Date.now() - cached.at < 60000) return cached.promise;
    const promise = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {method:'GET', credentials:'same-origin', cache:'no-store', signal:controller.signal, headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('Sample price unavailable');
        const data = await response.json();
        if (!Array.isArray(data.variants)) throw new Error('Invalid product response');
        return data;
      } finally { clearTimeout(timeout); }
    })();
    requests.set(key, {at:Date.now(), promise});
    promise.catch(() => { if (requests.get(key)?.promise === promise) requests.delete(key); });
    return promise;
  }
  async function verifiedPrice(current) {
    // Legacy links contain a variant ID, not a product reference. The title is
    // only a lookup hint: never display any result unless its variant ID matches.
    if (!current.handle) throw new Error('No sample lookup hint');
    for (const handle of [current.handle, current.handle + '-swatch']) {
      try {
        const data = await productJSON(handle);
        const variant = data.variants.find(item => String(item.id) === current.id);
        if (!variant || typeof variant.price !== 'number' || !Number.isSafeInteger(variant.price) || variant.price < 0) continue;
        const formatted = new Intl.NumberFormat('en-US', {style:'currency', currency}).format(variant.price / 100);
        return formatted.includes(currency) ? formatted : formatted + ' ' + currency;
      } catch (_) { /* Try the second exact-ID-validated naming convention. */ }
    }
    throw new Error('Unable to verify selected sample price');
  }
  async function sync(node) {
    const output = node.querySelector('[data-uc-swatch-label] [data-uc-swatch-price]');
    if (!output) return;
    const current = selection(node);
    if (!current) return;
    const key = currency + ':' + current.id + ':' + current.handle + ':' + current.price;
    let state = states.get(node);
    if (state?.key === key && (state.pending || state.text || Date.now() - state.at < 1500)) {
      if (state.text) setText(output, state.text);
      return;
    }
    state = {key, pending:!current.price, text:current.price ? ' — ' + current.price : '', at:Date.now()};
    states.set(node, state);
    setText(output, state.text);
    if (current.price) return;
    try {
      const price = await verifiedPrice(current);
      if (!node.isConnected || states.get(node) !== state || selection(node)?.id !== current.id) return;
      state.text = ' — ' + price;
      setText(output, state.text);
      output.removeAttribute('data-uc-price-error');
    } catch (_) {
      // Do not invent a price or block the existing sample add button on failure.
      if (node.isConnected && states.get(node) === state) output.setAttribute('data-uc-price-error', 'unavailable');
    } finally { state.pending = false; }
  }
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll(selector).forEach(sync);
    });
  }
  function init() {
    schedule();
    document.addEventListener('change', event => {
      if (event.target.closest?.('variant-selects')) schedule();
    });
    // Support section replacements and the existing handler clearing a label.
    new MutationObserver(records => {
      if (records.some(record => record.target.closest?.(selector) || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector))))) schedule();
    }).observe(document.body, {childList:true, subtree:true});
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
